import { MD5 } from "object-hash";

export function contentHash(content: string) {
    return MD5(content);
}
